import getStore from '../store/store';

export default function getPlaceholderRoomLists() {
    const { defaultRoomList } = getStore().roomListViewState;
    return defaultRoomList.email ? [defaultRoomList] : [];
}
